module.exports = __webpack_public_path__ + "static/media/hearclearpro-3.3115a792.jpg";